// HIDE STICKY FORM ON MOBILE WHEN USER SCROLL TO FOOTER
window.addEventListener('scroll', function () {
  let footerOffset = document.querySelector('.footer').getBoundingClientRect().top - window.innerHeight;
  if (footerOffset < 0) {
    document.querySelector('.product-form__variants-with-buy-button').classList.add('is-hidden');
  } else {
    document.querySelector('.product-form__variants-with-buy-button').classList.remove('is-hidden');
  }
});

// Show/hide variant picker
let toggleBtn = document.querySelector('.product-form__choose-variant-btn');
let variantPicker = document.querySelector('.variant-picker-container');
if (toggleBtn) {
  toggleBtn.addEventListener('click', () => {
    let texts = document.querySelectorAll('.choose-variant-btn');
    texts.forEach(text => {
      text.classList.toggle('is-hidden');
    });
    variantPicker.classList.toggle('is-open');
  });
}
window.addEventListener('load', function () {
  // Hide reviews section if there are no reviews
  let trustpilotIframe = document.querySelector('.trustpilot-widget iframe');
  let reviewsSection = document.querySelector('.shopify-section--customers-reviews');
  if (trustpilotIframe && trustpilotIframe.style.display == "none") {
    reviewsSection.style.display = "none";
  }
});

// Close open collapsible when on another tab is opened

let collapsibleToggle = document.querySelectorAll('.collapsible-toggle');
if (collapsibleToggle.length > 0) {
  collapsibleToggle.forEach(toggle => {
    toggle.addEventListener('click', function (event) {
      //If we are on mobile or if we are not in a product-tabs, we don't want to close the collapsible
      if (window.innerWidth < 1000 || !event.target.closest('.product-tabs')) {
        return;
      }
      let targetId = event.target.getAttribute('aria-controls');

      //If we click on the collapsible-toggle-link, we don't want to close the collapsible
      if (event.target.classList.contains('collapsible-toggle-link')) {
        return;
      }

      //If we click on a collapsible that is already open, we don't want to close it
      if (!document.getElementById(targetId).hasAttribute('open')) {
        document.getElementById(targetId).setAttribute('open', "true");
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      let allCollapsibles = event.target.closest('.product-tabs').querySelectorAll('.collapsible');
      allCollapsibles.forEach(collapsible => {
        if (collapsible.id !== targetId) {
          collapsible.removeAttribute('open');
        }
      });
    });
  });
}